import React from "react";
import { useTranslation } from "react-i18next";
import { SPOTNotification } from "spot-component-library/lib/components/notification/SPOTNotification";
import { RateAmountInput, RateAmountSlider, RateNumberInput, RateNumberSlider } from "../components";
import { RateCalculationRendererProps } from "./RateCalculationRenderer";

export const RateCalculationDefault: React.FC<RateCalculationRendererProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className={"rateBox"} data-test={"RateCalculationDefault"}>
            <div>
                <RateAmountInput
                    errors={props.errors}
                    label={t("CONFIGURATION_PAGE.RateAmountInputLabel")}
                    rateAgreementOptions={props.rateAgreementOptions}
                    rateData={props.rateData}
                    register={props.register}
                    onChange={props.onInputChange}
                />
                <RateAmountSlider rateData={props.rateData} rateAgreementOptions={props.rateAgreementOptions} onChange={props.onChangeRateAmount} />
                <div className={"minMaxRateBlock"}>
                    <span></span>
                    <span>Euro</span>
                </div>
            </div>
            <SPOTNotification text={t("CONFIGURATION_PAGE.TwelveRateNote")} active={props.isMaxRateAlerting} type={"warning"} />
            <div>
                <RateNumberInput
                    errors={props.errors}
                    label={t("CONFIGURATION_PAGE.RateNumberInputLabel")}
                    rateAgreementOptions={props.rateAgreementOptions}
                    rateData={props.rateData}
                    register={props.register}
                    onChange={props.onInputChange}
                />
                <RateNumberSlider rateData={props.rateData} rateAgreementOptions={props.rateAgreementOptions} onChange={props.onChangeRateNumber} />
                <div className={"minMaxRateBlock"}>
                    <span>{props.rateAgreementOptions.minNumberOfRates}</span>
                    <span>{props.rateAgreementOptions.maxNumberOfRates}</span>
                </div>
            </div>
            {props.children}
        </div>
    );
};
